export default "__VITE_ASSET__KKWm_mnE__"